import React from "react";
import SortOrderIndicators from "../SortOrderIndicators";

export default function HardcodedStartColumnTHs(props) {
  return (
    <>
      <th className="c-parts-listing__table-header"></th>
      <th
        className="c-parts-listing__table-header"
        onClick={() => props.changeSortProperty("code")}
        style={{ cursor: "pointer" }}
      >
        <div className="d-flex">
          <span style={{ textDecoration: props.sortProperty === "code" ? "underline" : "none" }}>
            {i18n.getString("articlelisting.artno")}
          </span>

          <SortOrderIndicators sortType={props.sortType} sortProperty={props.sortProperty} currentProperty={"code"} />
        </div>
      </th>
    </>
  );
}
